<template>
  <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.8" />
</template>
